import { render, staticRenderFns } from "./custom-detail.vue?vue&type=template&id=e3aa62ee&scoped=true&"
import script from "./custom-detail.vue?vue&type=script&lang=ts&"
export * from "./custom-detail.vue?vue&type=script&lang=ts&"
import style0 from "./custom-detail.vue?vue&type=style&index=0&id=e3aa62ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3aa62ee",
  null
  
)

export default component.exports